import { useState } from "react";
import { Link } from "react-router-dom";
import { languages } from "@/lib/scenes";
import AppHeader from "@/components/AppHeader";

export default function LandingPage() {
  const [selectedLanguage, setSelectedLanguage] = useState<string>("");
  const langs = languages as Record<string, { label: string; locale: string }>;

  return (
    <div className="page-shell">
      <AppHeader />
      <main className="landing">
        <section className="landing-hero">
          <p className="eyebrow">Welcome</p>
          <h1>Choose a language. Explore a scene. Learn by tapping.</h1>
          <p className="lede">
            Pick a target language, then tap into a cartoon scene — a kitchen,
            airport, hotel lobby, or wherever — to learn vocabulary in context.
          </p>
        </section>

        <section className="landing-panel">
          <div className="landing-header">
            <div>
              <p className="section-label">Step 1</p>
              <h2>What language do you want to learn?</h2>
            </div>
            <Link className="ghost-link" to="/lesson?scene=kitchen&lang=es">
              Skip to prototype
            </Link>
          </div>

          <div id="language-grid" className="choice-grid">
            {Object.entries(langs).map(([code, language]) => (
              <button
                key={code}
                type="button"
                className={`choice-card${selectedLanguage === code ? " is-active" : ""}`}
                onClick={() => setSelectedLanguage(code)}
              >
                <strong>{language.label}</strong>
                <span>{code.toUpperCase()}</span>
              </button>
            ))}
          </div>

          <div className="landing-actions">
            <p className="selection-note">
              {selectedLanguage
                ? `Selected language: ${langs[selectedLanguage].label}`
                : "No language selected yet."}
            </p>
            {selectedLanguage ? (
              <Link className="primary-button" to={`/scenes?lang=${selectedLanguage}`}>
                Choose a scene
              </Link>
            ) : (
              <span className="primary-button disabled-link" aria-disabled="true">
                Choose a scene
              </span>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}
